'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className", "headingLevel"];
import PropTypes from 'prop-types';
import classNames from 'classnames';
import UISubheader from 'UIComponents/layout/UISubheader';
import { jsx as _jsx } from "react/jsx-runtime";
const ResultsSectionHeader = props => {
  const {
      className,
      headingLevel
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const computedClasses = classNames('p-bottom-0', className);
  return /*#__PURE__*/_jsx(UISubheader, Object.assign({}, rest, {
    className: computedClasses,
    headingLevel: headingLevel
  }));
};
ResultsSectionHeader.propTypes = {
  className: PropTypes.string,
  headingLevel: PropTypes.string
};
ResultsSectionHeader.defaultProps = {
  headingLevel: 'h4'
};
export default ResultsSectionHeader;